import { PlusIcon, PlayIcon } from '@heroicons/react/24/outline';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../app/store';

export default function DashboardCTAs() {
  const navigate = useNavigate();
  const { isSessionActive } = useSelector((state: RootState) => state.sessions);

  return (
    <div className="flex gap-3">
      <button
        onClick={() => {
          navigate(isSessionActive ? '/sessions?end=1' : '/sessions?start=1', { replace: false });
        }}
        className={`btn ${isSessionActive ? 'btn-warning' : 'btn-success'}`}
      >
        <PlayIcon className="h-4 w-4 mr-2" />
        {isSessionActive ? 'Session Active' : 'Start Driving'}
      </button>
      <button
        onClick={() => {
          navigate('/expenses?new=1', { replace: false });
        }}
        className="btn-primary"
      >
        <PlusIcon className="h-4 w-4 mr-2" />
        Add Expense
      </button>
    </div>
  );
}
